import { useQuery } from 'react-query';

import dealService from 'resources/deal/deal.service';
import userService from 'resources/user/user.service';

const getDealsByUserId = async ({ userId, filters }) => {
  const deals = await dealService.getDealsByRealtorId(userId, filters);

  if (!deals) return null;

  const clientIds = deals.flatMap((deal) => deal.client_ids);
  const clients = await userService.getUsersByIds(clientIds);

  const dealsWithClients = deals.map((deal) => {
    const dealClients = clients.filter((client) => deal.client_ids.includes(client.id));

    return {
      ...deal,
      clients: dealClients,
    };
  });

  return dealsWithClients;
};

export default function useDealsByUserId({ userId, filters }, queryOptions) {
  return useQuery(
    ['deal.getByUserId', userId, filters],
    () => getDealsByUserId({ userId, filters }),
    queryOptions,
  );
}
